import type { ComponentWithProperties } from '@simonbackx/vue-app-navigation';
import { Formatter } from '@stamhoofd/utility';
import type { ComponentPublicInstance, Ref } from 'vue';
import { markRaw, unref } from 'vue';
import type { TranslatedUrl } from './TranslatedUrl';

/** A stable tab identity. Reuse items and their component wrappers to retain view state when switching tabs. */
export class TabBarItem {
    id: string;
    name: string = '';
    url?: TranslatedUrl;
    icon = '';
    badge: string | Ref<string> | null = '';
    component?: ComponentWithProperties;
    action?: (this: ComponentPublicInstance) => Promise<void> | void;
    savedScrollPositions: WeakMap<HTMLElement, number> = new WeakMap();

    constructor(options: { id?: string; name: string; icon: string; url?: TranslatedUrl; badge?: string | Ref<string> | null; component?: ComponentWithProperties; action?: (this: ComponentPublicInstance) => Promise<void> | void }) {
        this.id = options.id ?? Formatter.slug(options.name);
        this.name = options.name;
        this.icon = options.icon;
        this.component = options.component;
        this.badge = options.badge ?? '';
        this.url = options.url;
        this.action = options.action;

        // Not reactive because we need === operator to know what the active tab is
        markRaw(this);
    }

    get isGroup() {
        return false;
    }

    /**
     * Helper to treat groups and items the same
     */
    get items() {
        return [this];
    }

    isSelected(selectedItem: TabBarItem | Ref<TabBarItem> | null) {
        if (unref(selectedItem) === this) {
            return true;
        }
        return false;
    }
}

export class TabBarItemGroup {
    name = '';
    icon = '';
    badge: string | Ref<string> | null = '';
    items: TabBarItem[] = [];

    constructor(options: { name: string; icon: string; items: TabBarItem[] }) {
        this.name = options.name;
        this.icon = options.icon;
        this.items = options.items;

        // Not reactive because we need === operator to know what the active tab is
        markRaw(this);
    }

    get isGroup() {
        return true;
    }

    isSelected(selectedItem: TabBarItem | Ref<TabBarItem> | null) {
        return this.items.some(item => item.isSelected(selectedItem));
    }
}
